import state from './ads.state';
import mutations from './ads.mutations';
import actions from './ads.actions';
import getters from './ads.getters';

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/ads/index.js